<div (keyup.enter)="closeDialog()" class="content">
  <Label class="tokenLabel" i18n>No report added</Label>
</div>
<div>
  <button class="confirmButton" mat-button (click)="closeDialog()" i18n>
    Back
  </button>
</div>
